import { Modal, Box } from '@mui/material'
import React from 'react'
import { useStyles } from '../style'

export const SelfRegistrationModal = ({
  open,
  handleClose,
  id,
  header,
  body,
  footer
}) => {
  const classes = useStyles()

  return (
    <Modal
      open={open}
      data-test={id}
      onClose={handleClose}
      aria-labelledby={`${id}-title`}
      aria-describedby={`${id}-description`}
    >
      <Box className={classes.modal}>
        <Box data-test={`${id}-head`}>{header}</Box>

        <Box data-test={`${id}-body`}>{body}</Box>

        <Box data-test={`${id}-footer`}>{footer}</Box>
      </Box>
    </Modal>
  )
}
